import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=35cc6e36&scoped=true"
import script from "./vote.vue?vue&type=script&lang=ts"
export * from "./vote.vue?vue&type=script&lang=ts"
import style0 from "./vote.vue?vue&type=style&index=0&id=35cc6e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc6e36",
  null
  
)

export default component.exports